export default function CollapseTagsIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.5 2C6.15625 2 4.03125 3.25 2.84375 5.25C1.6875 7.28125 1.6875 9.75 2.84375 11.75C4.03125 13.7812 6.15625 15 8.5 15C10.8125 15 12.9375 13.7812 14.125 11.75C15.2812 9.75 15.2812 7.28125 14.125 5.25C12.9375 3.25 10.8125 2 8.5 2ZM8.5 16.5C5.625 16.5 3 15 1.5625 12.5C0.125 10.0312 0.125 7 1.5625 4.5C3 2.03125 5.625 0.5 8.5 0.5C11.3438 0.5 13.9688 2.03125 15.4062 4.5C16.8438 7 16.8438 10.0312 15.4062 12.5C13.9688 15 11.3438 16.5 8.5 16.5ZM6.25 7.75H10.75H11.5V9.25H10.75H6.25H5.5V7.75H6.25Z"
        fill="#6B6255"
      />
    </svg>
  );
}
